__webpack_require__.p = "/revelation-online-map/";